module.exports = __webpack_public_path__ + "static/media/InnerBox_Left.38562615.svg";